import { useEffect, useRef } from 'react';
import * as Yup from 'yup';
import {
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Stack,
} from '@chakra-ui/react';
import { v4 as uuid } from 'uuid';

import { useAuth } from '../../../hooks/auth';

import { Buttons, FormView } from './styles';
import { FormHandles } from '@unform/core';
import Input from '../../Inputs/Input';
import getValidationErrors from '../../../utils/getValidationErrors';

type PhoneFormData = {
	id: string;
	numero: string;
	obs: string;
	emp_cod: string;
};

interface NewTelClienteModalProps {
	isOpen: boolean;
	onRequestClose: (close: boolean) => void;
	setPhones: (phone: PhoneFormData[]) => void;
	phones: PhoneFormData[];
	phoneModal: PhoneFormData;
	setPhoneModal: (phone: PhoneFormData) => void;
};

const NewPhoneClienteModal: React.FC<NewTelClienteModalProps> = ({ 
	isOpen,
	onRequestClose,
	setPhones,
	phones,
	phoneModal,
	setPhoneModal,
}) => {
	const formRef = useRef<FormHandles>(null);

	const { company } = useAuth();

	useEffect(() => {
		formRef.current?.reset();
	}, []);

	function handleMaskPhone(event: string) {
		let res = event;
		res = res.replace(/\D/g, '');
		res = res.replace(/^(\d{2})(\d)/g, '($1) $2');
		res = res.replace(/(\d)(\d{4})$/, '$1-$2');
		formRef.current?.setFieldValue('numero', res);
	};

	async function handleSubmitPhone(form: any) {
		try {
			formRef.current?.setErrors({});

			const schema = Yup.object().shape({
				numero: Yup.string().required('Número é obrigatório'),
				obs: Yup.string(),
			});

			await schema.validate(form, {
				abortEarly: false,
			});

			if (phoneModal.id) {
				const endIndex = phones.findIndex(end => end.id === phoneModal.id);
				phones[endIndex] = { ...form };
				setPhones(phones);
			} else {
				const phone = { ...form, id: uuid(), emp_cod: company.id };
				setPhones([...phones, phone]);
			}

			setPhoneModal({} as PhoneFormData);
			formRef.current?.reset();
			onRequestClose(false);
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errors = getValidationErrors(err);
				formRef.current?.setErrors(errors);
			}
		}
	};

	return (
		<Modal
			isCentered={true}
			closeOnOverlayClick={false}
			blockScrollOnMount={false}
			size="lg"
			isOpen={isOpen}
			onClose={() => onRequestClose(false)} 
		>

			<ModalOverlay />

			<ModalContent w={["98%", "100%"]}>
				<ModalHeader>Novo Telefone</ModalHeader>
				<ModalCloseButton />

				<FormView ref={formRef} initialData={phoneModal} onSubmit={handleSubmitPhone}>
					<ModalBody>
						{/* NÚMERO - OBSERVAÇÃO */}
						<Stack w="100%" spacing={1} direction="column">
							{/* NÚMERO */}
							<div className="input">
								<p>Número <span>(obrigatório)</span></p>
								<Input
									name="numero"
									type="text"
									placeholder="Número"
									maxLength={15}
									onChange={(e: any) => handleMaskPhone(e.target.value)}
									containerStyle={{ padding: '6px 0 6px 10px' }}
								/>
							</div>

							{/* OBSERVAÇÃO */}
							<div className="input">
								<p>Observação <span>(obrigatório)</span></p>
								<Input
									name="obs"
									type="text"
									placeholder="Observação"
									containerStyle={{ padding: '6px 0 6px 10px' }}
								/>
							</div>
						</Stack>
					</ModalBody>

					<ModalFooter>
						<Buttons>
							<button
								type="button"
								className="button-cancel"
								onClick={() => onRequestClose(false)}
							>
								Cancelar
							</button>

							<button
								type="submit"
								className="button-save"
							>
								Adicionar
							</button>
						</Buttons>
					</ModalFooter>
				</FormView>
			</ModalContent>
		</Modal>
	)
}

export default NewPhoneClienteModal;

/*
<Modal
			isOpen={isOpen}
			onRequestClose={onRequestClose}
			overlayClassName="react-modal-overlay"
			className="react-modal-content"
		>
			<button
				type='button'
				onClick={onRequestClose}
				className="react-modal-close"
			>
				<Icon as={RiCloseLine} fontSize="20" />
			</button>

			<Input
				label="Telefone"
				error={formState.errors.phone}
				icon={RiPhoneLine}
				{...register("phone")}
			/>
		</Modal>
*/